import React from 'react';
import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import cx from 'classnames';
import styles from './ChatThreadOptionsMenu.module.scss';

export interface ChatThreadOptionsMenuProps {
  threadId: string;
  onRename: () => void;
  onArchive: () => void;
}

const ChatThreadOptionsMenu: React.FC<ChatThreadOptionsMenuProps> = ({
  threadId,
  onRename,
  onArchive,
}) => {
  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger
        className={styles.triggerButton}
        onClick={(e) => e.stopPropagation()}
        title="Thread options"
        aria-label="Thread options"
        data-testid={`thread-options-trigger-${threadId}`}
      >
        <span className="material-icons">more_vert</span>
      </DropdownMenu.Trigger>

      <DropdownMenu.Portal>
        <DropdownMenu.Content
          className={styles.menuContent}
          align="end"
          sideOffset={4}
          data-testid={`thread-options-menu-${threadId}`}
        >
          <DropdownMenu.Item
            className={styles.menuItem}
            onSelect={onRename}
            data-testid="thread-option-rename"
          >
            <span className={cx(styles.menuItemIcon, 'material-icons')}>
              edit
            </span>
            Rename
          </DropdownMenu.Item>

          <DropdownMenu.Item
            className={cx(styles.menuItem, styles.menuItemDelete)}
            onSelect={onArchive}
            data-testid="thread-option-delete"
          >
            <span className={cx(styles.menuItemIcon, 'material-icons')}>
              delete
            </span>
            Delete
          </DropdownMenu.Item>
        </DropdownMenu.Content>
      </DropdownMenu.Portal>
    </DropdownMenu.Root>
  );
};

export default ChatThreadOptionsMenu;
